import type CrudAction from '@/features/crud/CrudAction';

import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '@/features/crud/CrudActionType';

const TrafficSourcesPage = async () => import('@/pages/TrafficSourcesPage.vue');

export default function getTrafficSourcesRoutes(): RouteRecordRaw[] {
  return [
    {
      name: 'traffic-sources',
      component: TrafficSourcesPage,
      meta: {
        title: 'Traffic sources',
        useIn: ['navigation-tabs'],
      },
      path: '/traffic-sources',
      props: () => ({
        crudAction: null,
      }),
    },
    {
      name: 'create-traffic-source',
      component: TrafficSourcesPage,
      path: '/traffic-sources/create',
      props: (): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          type: CrudActionType.CREATE,
        },
      }),
    },
    {
      name: 'edit-traffic-source',
      component: TrafficSourcesPage,
      path: '/traffic-sources/edit/:id',
      props: (
        route,
      ): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          id: route.params.id as string,
          type: CrudActionType.EDIT,
        },
      }),
    },
    {
      name: 'clone-traffic-source',
      component: TrafficSourcesPage,
      path: '/traffic-sources/clone/:id',
      props: (
        route,
      ): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          id: route.params.id as string,
          type: CrudActionType.CLONE,
        },
      }),
    },
  ];
}
